import React, { useState, useEffect } from 'react'
import { Button, Icon } from '@equinor/eds-core-react'
import styled from 'styled-components'
import { colors } from '@/styles'
import { Tooltip } from '@equinor/eds-core-react'

interface ICardViewButton {
    cardViewButtonIcon: string
    onToggle?: () => void
}

const CardViewButton: React.FC<ICardViewButton> = ({ cardViewButtonIcon, onToggle }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const layoutLabel = 'Layout'

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return (
        <>
            <Tooltip title="Switch dashboard view">
                {windowWidth > 1024 ? (
                    <CardViewButtonStyled variant="outlined" onClick={onToggle}>
                        <Icon name={cardViewButtonIcon}></Icon>
                        {layoutLabel}
                    </CardViewButtonStyled>
                ) : (
                    <CardViewButtonStyled color="secondary" onClick={onToggle}>
                        <Icon name={cardViewButtonIcon}></Icon>
                        {windowWidth > 400 ? layoutLabel : ''}
                    </CardViewButtonStyled>
                )}
            </Tooltip>
        </>
    )
}

const CardViewButtonStyled = styled(Button)`
    width: 105px;
    height: 38px;
    border: none;
    padding: 0 16px;

    @media (max-width: 1024px) {
        border: 1px solid;
    }
`

export default CardViewButton
